import styled from "styled-components";
import * as common from "../../common";

export const footer = styled(common.flexRow)``;
